import * as React from 'react'
import { useTheme } from "styled-components"
import { OfferedQuantityDiscountBase } from "../../../../services/json-schemas/base/offered_quantity_discount"
import { offeredQuantityDiscountsI18nQuantityWithUnit } from "../../../../services/models/offered-quantity-discounts.service"
import { I18nService } from '../../../../services/utils/i18n.service'

type OfferedQuantityDiscountForName = Pick<OfferedQuantityDiscountBase, 'quantity_commitment' | 'unit_of_work' | 'validity_duration_in_months' | 'discount_percentage'>

interface Props {
  offeredQuantityDiscount: OfferedQuantityDiscountForName
  compact?: boolean
}

const i18nScoped = new I18nService(require('./casting-quantity-discount-name.component.yml'))

export function CastingQuantityDiscountNameComponent ({ offeredQuantityDiscount, compact }: Props) {
  const theme = useTheme()
  const formattedQuantity = offeredQuantityDiscountsI18nQuantityWithUnit(offeredQuantityDiscount.quantity_commitment, offeredQuantityDiscount.unit_of_work)

  return <div style={ compact ? {} : { display: 'flex', justifyContent: compact ? 'flex-start' : 'space-between', gap: '0.5em' } }>
    { i18nScoped.t('formatted_discount_conditions', { quantity: formattedQuantity, count: offeredQuantityDiscount.validity_duration_in_months }) }
    { compact && <>&nbsp;</> }
    <span style={{ ...(compact ? {} : { display: 'inline-block', flexShrink: 0, height: 'fit-content' }), backgroundColor: theme.colors.clr_1, color: 'white', fontWeight: 'bold', borderRadius: '1em', padding: '0 0.5em', whiteSpace: 'nowrap' }}>
      -&nbsp;{ offeredQuantityDiscount.discount_percentage }&nbsp;%
    </span>
  </div>
}
